import { Enum } from './Enum';

export class PODShuffleErrorType extends Enum {
  translationKey = 'podShuffleErrorType';

  static asArray: PODShuffleErrorType[] = [];

  static byKey: { [name: string]: PODShuffleErrorType } = {};

  static readonly POD_MISMATCH = new PODShuffleErrorType('POD_MISMATCH');

  static readonly TECHNICAL_ERROR = new PODShuffleErrorType('TECHNICAL_ERROR');

  constructor(public readonly value: string) {
    super();
    PODShuffleErrorType.asArray.push(this);
    PODShuffleErrorType.byKey[value] = this;
  }
}
